import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import WPAgGrid from "../../../packages/WPAgGrid/WPAgGrid";

import { CHEMICAL_LIB_TABLE_CONFIG } from "./ChemicalLibraryTable.config";

import { FEATURE_SCOPE } from "../../../constants/global.constants";

import "./ChemicalLibraryTable.scss";

const getChemicalRowId = (chemical = {}) =>
  String(chemical?.tempChemicalId ?? chemical?.id);

const ChemicalLibraryTable = ({
  chemicalLibrary,
  context,
  scope,
  isLoading,
  onSubmit,
  shouldResetData,
}) => {
  const gridApiRef = useRef(null);
  const { t } = useTranslation();

  const [columnDefs, setColumnDefs] = useState(
    CHEMICAL_LIB_TABLE_CONFIG(t, scope),
  );

  useEffect(() => {
    const colDefs = CHEMICAL_LIB_TABLE_CONFIG(t, scope);
    setColumnDefs(colDefs);
  }, [t, scope]);

  useEffect(() => {
    if (!gridApiRef.current || !shouldResetData) {
      return;
    }

    const api = gridApiRef.current.api;

    chemicalLibrary.forEach((chemical) => {
      const rowNode = api.getRowNode(getChemicalRowId(chemical));
      if (rowNode) {
        rowNode.updateData({ ...chemical });
      }
    });

    api.refreshCells({ force: true });
  }, [shouldResetData, chemicalLibrary]);

  const onChemicalDataChange = (newData) => {
    const rowNode = gridApiRef.current?.api.getRowNode(
      getChemicalRowId(newData),
    );
    if (!rowNode) {
      return;
    }

    const updatedData = { ...rowNode.data, ...newData };
    rowNode.updateData(updatedData);
    onSubmit(updatedData, newData?.hasError);
  };

  const onGridReady = (params) => (gridApiRef.current = params);

  return (
    <div className="ro-ag-table chemical-library-table">
      <WPAgGrid
        gridRef={gridApiRef}
        getRowId={(params) => getChemicalRowId(params.data)}
        columnDefs={columnDefs}
        rowData={chemicalLibrary}
        rowSelection={null}
        gridOptions={{ suppressRowClickSelection: true }}
        tableHeight={scope === FEATURE_SCOPE.USER ? "360px" : "310px"}
        isLoading={isLoading}
        onGridReady={onGridReady}
        context={{ ...context, onChemicalDataChange }}
      />
    </div>
  );
};

export default ChemicalLibraryTable;
